import {
  BalanceStackedData,
  CompletePayoutRequestFormData,
  PaAccounts,
  TPaAccountHistory,
  TViewAccountStatsRes,
  PayoutActionParams,
  PayoutRequest,
  PayoutRes,
  StackedData,
} from '@src/types';
import axios, { AxiosResponse } from 'axios';

export const getPaAccounts = async (): Promise<AxiosResponse<PaAccounts[]>> => {
  return axios.get('/pa-accounts/');
};

export const getPaAccountsHistories = async (): Promise<
  AxiosResponse<TPaAccountHistory[]>
> => {
  return axios.get('/pa-accounts/histories/');
};

export const requestPayout = async (
  payload: PayoutRequest
): Promise<AxiosResponse<PaAccounts>> => {
  return axios.post('/pa-accounts/request-payout', payload);
};

export const getPayouts = async (): Promise<AxiosResponse<PayoutRes>> => {
  return axios.get('/payouts/');
};

export const getPayoutHistories = async (
  leeloo_user_id?: number
): Promise<AxiosResponse<PayoutRes>> => {
  return axios.get('/payouts/histories', { params: { leeloo_user_id } });
};

export const getPayoutStatus = async (
  account_id: number
): Promise<AxiosResponse<PaAccounts>> => {
  return axios.get(`/pa-accounts/${account_id}/payout-status`);
};

export const getPayoutManualInfo = async (
  account_id: number
): Promise<AxiosResponse<any>> => {
  return axios.get(`/pa-accounts/${account_id}/payout-manual-info`);
};

export const requestPayoutManual = async (
  payload: Record<string, any>
): Promise<AxiosResponse<any>> => {
  return axios.post('/pa-accounts/request-payout-manual', payload);
};

export const payoutAction = async (
  params: PayoutActionParams
): Promise<AxiosResponse<PaAccounts>> => {
  return axios.post(`/payouts/${params.payout_id}/actions/`, params);
};

export const makePayment = async (
  payout_id: number,
  params: CompletePayoutRequestFormData
): Promise<AxiosResponse<PaAccounts>> => {
  return axios.post(`/payouts/${payout_id}/make-payment/`, params);
};

export const getDailyTradeVolumesAndContracts = async (
  account_id: number
): Promise<AxiosResponse<StackedData[]>> => {
  return axios.get(
    `/leeloo-account-stats/chart/${account_id}/daily-trade-volumes-and-contracts/`
  );
};

export const getDailyProfitLossAndBalance = async (
  account_id: number
): Promise<AxiosResponse<BalanceStackedData[]>> => {
  return axios.get(
    `/leeloo-account-stats/chart/${account_id}/daily-profit-loss-and-balance/`
  );
};

export const viewAccountStats = async (
  account_id: number
): Promise<AxiosResponse<TViewAccountStatsRes>> => {
  return axios.get(`/leeloo-account-stats/view-stats/${account_id}/`);
};

export const addNotes = async (
  payout_id: number,
  notes: string
): Promise<AxiosResponse<boolean>> => {
  return axios.post(`/payouts/${payout_id}/notes/`, { notes });
};

export const generatePayoutReport = async (
  payload: Record<string, any>
): Promise<
  AxiosResponse<{
    count: number;
    download_url: string;
    message: string;
  }>
> => {
  return axios.post('/payouts/reports/generate', payload);
};

export const downloadPayoutReport = async (
  download_url: string
): Promise<AxiosResponse<any>> => {
  return axios.post(
    `/payouts/reports/download/`,
    { download_url },
    { responseType: 'blob' }
  );
};
